import api from "@/services/api";

/**
 * Envia contato para lista de liberação mobile
 * @param {Object} payload
 * @param {"email" | "whatsapp"} payload.type
 * @param {string} payload.value
 */
export async function registerMobileWaitlist(payload) {
  try {
    const response = await api.post("/support/mobile-waitlist", payload);
    return response.data;
  } catch (error) {
    // Normaliza erro (padrão do projeto)
    throw (
      error?.response?.data ||
      new Error("Erro ao registrar contato na lista mobile.")
    );
  }
}